import { IFRAME_POST_MESSAGE_FORM_SUBMITTED } from 'components/ContactForm/const/constants';

export const postMessageToParent = () => {
  setTimeout(() => {
    window.parent.postMessage({ height: document.body.scrollHeight }, '*');
  }, 100);
};

export const handleIframeMessage = (event: MessageEvent) => {
  if (event.data !== 'height') {
    return;
  }

  if (!(event.source instanceof MessagePort)) {
    event.source?.postMessage({ height: document.body.scrollHeight }, '*');
  }
};

export const formSubmissionNotifier = () => {
  window?.top?.postMessage({ message: IFRAME_POST_MESSAGE_FORM_SUBMITTED }, '*');
};
